module.exports = __webpack_public_path__ + "img/datacenter.905009ee.svg";